import {useParams} from 'react-router-dom';

import {portMonitorAPI} from 'features/port/api/portMonitorAPI';
import {getPortMonitorBackgroundKind, PortMonitorBackgroundKind} from 'features/port/lib/portMonitorHelper';
import useBreakpoint from 'shared/lib/hooks/useBreakpoint';
import {isTranslate} from 'shared/lib/lang';
import {getPollingInterval} from 'shared/api/pollingHelper';

import IPortMonitor from './PortMonitor/IPortMonitor';

export interface IUsePortMonitorDetails {
    portMonitor: IPortMonitor | undefined,
    isLoading: boolean,
    isMobile: boolean,
    backgroundKind: PortMonitorBackgroundKind | null,
}

export const usePortMonitorDetails = (): IUsePortMonitorDetails => {
    const {portMonitorId} = useParams<{portMonitorId: string}>();
    const breakpoint = useBreakpoint();

    const {data: portMonitor, isLoading} = portMonitorAPI.useGetPortMonitorQuery(portMonitorId ?? '', {
        skip: !portMonitorId,
        pollingInterval: getPollingInterval(),
    });

    return {
        portMonitor,
        isLoading,
        isMobile: breakpoint === 'small' || breakpoint === 'mini',
        backgroundKind: portMonitor ? getPortMonitorBackgroundKind(portMonitor, isTranslate()) : null,
    };
};

export default usePortMonitorDetails;
